import React from 'react';
import { useComponentManager } from '../../providers/ComponentManagerProvider';
import { ComponentNavigator } from './ComponentNavigator';
import { Breadcrumb } from './Breadcrumb';
import { StructureDetailPanel } from './StructureDetailPanel';

export const StructureTab = ({ onError, onAddChild, onEdit, onDelete, deleting, detailRefreshKey }) => {
    const { columns, selectedPath, selectComponent, loadingColumnIndex } = useComponentManager();

    const handleError = () => onError && onError('Failed to load component children.');

    return (
        <div className="structure-tab" data-testid="structure-tab">
            <Breadcrumb onError={handleError} />
            <ComponentNavigator
                columns={columns}
                selectedPath={selectedPath}
                onSelect={selectComponent}
                loadingColumnIndex={loadingColumnIndex}
                onError={handleError}
            />
            <StructureDetailPanel
                onAddChild={onAddChild}
                onEdit={onEdit}
                onDelete={onDelete}
                deleting={deleting}
                refreshKey={detailRefreshKey}
            />
        </div>
    );
};
